import { render } from "./PaisList.vue?vue&type=template&id=da20aaf0&scoped=true"
import script from "./PaisList.vue?vue&type=script&lang=js"
export * from "./PaisList.vue?vue&type=script&lang=js"

import "./PaisList.vue?vue&type=style&index=0&id=da20aaf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da20aaf0"]])

export default __exports__